import { Button, Flex, Heading, Text } from '@chakra-ui/react';
import { ReactElement } from 'react';
import { useTranslation } from 'react-i18next';

interface NotFoundProps {
  title?: string;
  description?: string;
  children?: ReactElement | ReactElement[];
}

const NotFound = ({ title, description, children }: NotFoundProps): ReactElement => {
  const { t } = useTranslation('not_found', { useSuspense: false });

  return (
    <Flex
      style={{
        position: 'absolute',
        height: '100vh',
        width: '100%',
        padding: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        flexDirection: 'column',
        color: 'white',
        backgroundColor: '#0d2860',
        backgroundImage: 'url(https://s3.amazonaws.com/media.venngage.com/img/bg-world-404.png)',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'auto',
        backgroundPosition: 'center',
        textAlign: 'center',
      }}
    >
      <Heading as='h1' mb={4}>
        {title || t('title')}
      </Heading>
      <Text mb={8}>{description || t('phishing')}</Text>
      {children ? (
        children
      ) : (
        <Button variant='upgrade' as='a' href='https://help.venngage.com/hc/en-us/' target='_blank'>
          {t('contactUs')}
        </Button>
      )}
    </Flex>
  );
};

export default NotFound;
